import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SubjectTypeIconsFetchFailedAction = {
	type: 'SUBJECT_TYPE_ICONS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SubjectTypeIconsFetchFailedAction => ({
	type: 'SUBJECT_TYPE_ICONS_FETCH_FAILED',
	payload,
});
